import React from 'react'
import elevation2 from '../img/Elevation/2.jpeg'
import elevation3 from '../img/Elevation/3.jpeg'
import elevation4 from '../img/Elevation/4.jpeg'
import elevation5 from '../img/Elevation/5.jpeg'
import elevation6 from '../img/Elevation/6.jpeg'
import elevation7 from '../img/Elevation/7.jpeg'
import elevation8 from '../img/Elevation/8.jpeg'
import elevation9 from '../img/Elevation/9.jpeg'
import elevation1 from '../img/Elevation/1.jpeg'
import '../styles/elevation.css';
import {AnimationOnScroll} from 'react-animation-on-scroll'

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function Elevation() {
  const location = useLocation();
    const componentRef = useRef(null);

    useEffect(() => {
        if (componentRef.current) {
            setTimeout(() => {

                componentRef.current.scrollIntoView({ behavior: "smooth" });
            }, 3000);
        }
    }, [location])
  return (
    <section ref={componentRef}>
      <div className="about">
        <h3 id="Content">Elevation</h3>
      </div>
      <div className="my-3 ElevationImage">

        <img src={elevation2} alt="" className="elevation"/>
        <img src={elevation3} alt="" className="elevation"/>
        <img src={elevation4} alt="" className="elevation"/>
        <img src={elevation5} alt="" className="elevation"/>
        <img src={elevation6} alt="" className="elevation"/>
        <img src={elevation7} alt="" className="elevation"/>
        <img src={elevation8} alt="" className="elevation"/>
        <img src={elevation9} alt="" className="elevation"/>
        <img src={elevation1} alt="" className="elevation"/>
       </div> 
    </section>
  )
}

export default Elevation
